import { useMutation } from '@tanstack/react-query';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceLiquidity = () => {
  return useMutation({
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceLiquidity,
  });
};
